<template>
  <div class="con" v-loading="loading">
    <div class="text item">
      <network-info :network-info="networkInfo"></network-info>
      <div class="setting">{{$t('lang.wire.functionConfiguration')}}</div>
      <!-- 协议为静态地址显示 -->
      <div class="box-card" v-show="data.proto==='static'">
        <div v-show="data.proto==='static'" class="text">
          <div class="Table-Con">
          <el-form ref="ruleForm" label-width="320px" class="demo-ruleForm">
            <el-form-item :label="`${$t('lang.ConfigSetting.Protocol')}：`" prop="name">
              <el-select :placeholder="$t('lang.ConfigSetting.pleaseChoose')" v-model="data.proto" size="mini" class="Form-Input-Width">
                <el-option
                  v-for="item in protocol"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="`${$t('lang.ConfigSetting.IPv4address')}：`" prop="name">
              <el-input size="mini" class="Form-Input-Width" v-model="data.ipaddr" @change="ErrorIp(data.ipaddr,'ipaddr')"></el-input>
              <p class="error-mess" v-if="error.ipaddr">{{$t('lang.ConfigSetting.Pleasecheck')}}</p>
            </el-form-item>
            <el-form-item :label="`${$t('lang.ConfigSetting.IPv4netmask')}：`" prop="region">
              <select-input :SelectArr="IPv4protocol" :SelectValue="data.netmask"
              @GetSelectValue="GetSelectValue"></select-input>
            </el-form-item>
            <el-form-item :label="`${$t('lang.ConfigSetting.IPv4gateway')}：`" prop="region">
              <el-input size="mini" class="Form-Input-Width" v-model="data.gateway" @change="ErrorIp(data.gateway,'gateway')"></el-input>
              <p class="error-mess" v-if="error.gateway">{{$t('lang.ConfigSetting.Pleasecheck')}}</p>
            </el-form-item>
            <el-form-item :label="`${$t('lang.ConfigSetting.UsecustomDNSservers')}：`" prop="region">
              <add-input :dns="data.dns" @GetAddInput="GetAddInput"></add-input>
            </el-form-item>
            <!-- <el-form-item label="重设 MAC 地址：" prop="region">
              <el-input size="mini" class="Form-Input-Width" v-model="data.macaddr"></el-input>
            </el-form-item>
            <el-form-item label="重设 MTU：" prop="region">
              <el-input size="mini" class="Form-Input-Width" v-model="data.mtu"></el-input>
            </el-form-item>
            <el-form-item label="使用网关跃点：" prop="region">
              <el-input size="mini" class="Form-Input-Width" v-model="data.metric"></el-input>
            </el-form-item> -->
          </el-form>
          </div>
        </div>
        <el-button type="danger" size="mini" @click="updateConfig" class="Config-Buttom">
          {{$t('lang.ConfigSetting.SaveApply')}}
        </el-button>
      </div>
      <!-- 协议为DHCP显示 -->
      <div class="box-card" v-show="data.proto==='dhcp'">
        <div class="text item">
          <div class="Table-Con">
          <el-form ref="ruleForm" label-width="320px" class="demo-ruleForm">
            <el-form-item :label="`${$t('lang.ConfigSetting.Protocol')}：`" prop="name">
              <el-select :placeholder="$t('lang.ConfigSetting.pleaseChoose')" v-model="data.proto" size="mini" class="Form-Input-Width">
                <el-option
                  v-for="item in protocol"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="`${$t('lang.ConfigSetting.DHCP')}：`" prop="name">
              <el-input size="mini" class="Form-Input-Width" v-model="data.hostname" @change="ErrorHost(data.hostname,'hostname')"></el-input>
              <p class="error-mess" v-if="error.hostname">{{$t('lang.ConfigSetting.Pleasecheck')}}</p>
            </el-form-item>
          </el-form>
          </div>
        </div>
        <el-button type="danger" size="mini" @click="updateConfig" class="Config-Buttom">
          {{$t('lang.ConfigSetting.SaveApply')}}
        </el-button>
      </div>
    </div>
   
  </div>
</template>
<script>
import SelectInput from "../../../SelectInput/index";
import AddInput from "../../../AddInput/index";
import networkInfo from '../../../networkInfo/index'

import { updateConfig, listConfig, getNetworkInfo } from '@/api/configurationlist'
import { cloneDeep, isEqual } from 'lodash'

export default {
  props:["deviceDid", "deviceSn"],
  data() {
    return {
      protocol: [
        { label: this.$t('lang.ConfigSetting.Staticaddress'), value: "static" },
        { label: this.$t('lang.ConfigSetting.DHCPclient'), value:"dhcp" }
      ],
      protocolVlue: "dhcp",
      IPv4protocol: [
        { label: "255.255.255.0", value: "255.255.255.0" },
        { label: "255.255.0.0", value: "255.255.0.0" },
        { label: "255.0.0.0", value: "255.0.0.0" },
        { label: this.$t('lang.ConfigSetting.custom'), value: "自定义" }
      ],
      IPv4protocolValue: "255.255.255.0",
      checked:true,
      data: {},
      WatchData:{
        proto:'',
        dns:'',
        ipaddr:'',
        netmask:'',
        gateway:'',
        hostname:'',
        metric:'',
        macaddr:'',
        mtu:''
      },
      loading:true,
      error:{
        ipaddr:false,
        gateway:false,
        hostname:false
      },
      // 网络接口基本信息
      networkInfo: {},
    };
  },
  watch: {
    deviceSn: {
      immediate: true,
      handler(newValue, oldValue) {
        this.getConfig()
      },
    }
  },
  activated() {
    this.fetchNetworkInfo()
    this.timer = setInterval(() => {
      this.fetchNetworkInfo()
    }, 10000)
  },
  deactivated() {
    clearInterval(this.timer)
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  methods: {
    // 获取配置参数
    getConfig() {
      this.loading = true
      clearInterval(this.timer)
      listConfig(this.deviceSn, this.deviceDid, [
        {
          section: "wan",
          config: "network",
          options: [
            { option: "proto" },
            { option: "dns" },
            { option: "ipaddr" },
            { option: "netmask" },
            { option: "gateway" },
            { option: "hostname" },
            { option: "metric" },
            { option: "macaddr" },
            { option: "mtu" }
          ]
        }
      ]).then(res => {
        this.data = res.data.data.mess[0].s_objects[0].options;
        this.WatchData = cloneDeep(this.data)
        this.fetchNetworkInfo()
        this.timer = setInterval(() => {
          this.fetchNetworkInfo()
        }, 10000)
        this.loading = false
      }).catch(err => {
          this.$message({
            message: this.$t('lang.request.timeout'),
            type: "warning"
          });
      });
    },
     // 获取lan接口基本信息
    fetchNetworkInfo() {
      getNetworkInfo(this.deviceDid, this.deviceSn, ['wan']).then(res => {
        this.networkInfo = res.data.data.mess.wan
      })
    },
    //接收SelectInput的改变传过来的值
    GetSelectValue(props){
      this.data.netmask=props
    },
    //接收AddInput的改变传过来的值
    GetAddInput(props){
      this.data.dns=props
    },
    //提交修改
    updateConfig(){
      if(this.data.proto==='static'){
        if(this.error.ipaddr||this.error.gateway){
          return
        }
      }else if(this.data.proto==='dhcp'){
        if(this.error.hostname){
          return
        }
      }
      let data={}
      //循环筛选不为空的值，(不为空则未修改无需上传)
      for(let key in this.data){
        if(this.data[key]!==''){
         data[key]=this.data[key]
        }
      }
      if(Object.keys(data).length>0){
        if(!isEqual(this.WatchData, this.data)){
          clearInterval(this.timer)
          //提交修改
          updateConfig(this.deviceSn,this.deviceDid,[
            { section: "wan",
              config: "network",
              action:0,
              index:[0],
              server:'network',
              options:{
                ...data
              }
            }
          ]).then((res)=>{
            if(res.data.data.mess===0){
              this.$message({
                showClose: true,
                message: this.$t('lang.ConfigSetting.Successfulconfiguration'),
                type: 'success'
              });
              this.getConfig()
            }else {
              this.$message({
                showClose: true,
                message: this.$t('lang.ConfigSetting.Configurationerror'),
                type: 'warning'
              });
              return
            }
          })
        }else{
          this.$message({
            showClose: true,
            message: this.$t('lang.ConfigSetting.Nochangesmade'),
            type: 'warning'
          });
          return
        } 
       
      }else {
        this.$message({
          showClose: true,
          message: this.$t('lang.ConfigSetting.Configurationerror'),
          type: 'warning'
        });
        return
      }
    },
    //ip验证
    ErrorIp(props,key){
      let test=/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/
      let retu=false
      if(!test.test(props)){
        this.error[key]=true
        retu=true
      }
      if(!props){
        this.error[key]=false
        retu=false
      }
      if(!retu){
      this.error[key]=false
      }
    },
    //不为中文验证
    ErrorHost(props,key){
      let test=/^[a-z0-9]+$/i
      let retu=false
      if(!test.test(props)){
        this.error[key]=true
        retu=true
      }
      if(!props){
        this.error[key]=false
        retu=false
      }
      if(!retu){
      this.error[key]=false
      }
    },
  },
  components:{
    SelectInput,
    AddInput,
    networkInfo
  },
};
</script>

<style src='../../../common.css' scoped></style>
